const windowTplUrl = require('./modal-window.html');

function msiModalConfig($uibModalProvider) {
  $uibModalProvider.options.windowTemplateUrl = windowTplUrl;
  $uibModalProvider.options.windowClass = 'og-modal-window';
}

msiModalConfig.$inject = ['$uibModalProvider'];

module.exports = msiModalConfig;
